export default {"src":"/_next/static/media/meditation.mono.00807678.svg","height":364,"width":364,"blurWidth":0,"blurHeight":0};